import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IVariationInput } from "@/interfaces/variation.interface";
import variationService from "@/services/variation.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: IVariationInput;
} & RequestsProps;

export type UseReturn = {
  create: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useCreateVariation = (): UseReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IVariationInput>({
    operation: (formData) => variationService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateVariation;
